import { Button } from '@mui/material';
import { useAuthContext } from '../../contexts/AuthContext';
import { Lock, LockOpen } from '@mui/icons-material';

export function NavbarImpersonationLock() {
  const { impersonationLock, setImpersonationLock } = useAuthContext();

  return (
    <Button
      variant="secondary"
      startIcon={impersonationLock ? <Lock /> : <LockOpen />}
      onClick={() => setImpersonationLock(!impersonationLock)}
      sx={{
        '.MuiButton-startIcon': {
          mx: { xs: 0, sm: 0.5 },
        },
        '& .button-text': {
          display: { xs: 'none', md: 'inline' },
        },
      }}
    >
      <span className="button-text">
        {impersonationLock ? 'Unlock' : 'Lock'}
      </span>
    </Button>
  );
}
